import { Modal, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { IBaseModalProps, IStyleProps } from './types';
import useStyles from './style';

// TODO: refratorar demais modais para usar este componente base nas grids de Planejament e Inspeção;

const ActionsButtonsBaseModal = ({
  title,
  open,
  onClose,
  children,
  body,
  footer,
  width,
  disableBackDropClickByReasons = [],
}: IBaseModalProps & IStyleProps) => {
  const classes = useStyles({ width } as IStyleProps);

  return (
    <>
      {children}
      <Modal
        open={open}
        onClose={(event, reason) => {
          if (
            disableBackDropClickByReasons &&
            disableBackDropClickByReasons.some(
              backDropReason => backDropReason === reason,
            )
          ) {
            return;
          }

          onClose();
        }}
        className={classes.presentation}
      >
        <div className={classes.modalPresentation}>
          <div className={classes.modalCard}>
            <div className={classes.modalHeader}>
              <Typography variant="h3" className={classes.headerTitle}>
                {title}
              </Typography>
              <Close className={classes.headerIcon} onClick={onClose} />
            </div>
            <div className={classes.modalBody}>{body}</div>
            <div className={classes.modalFooter}>{footer}</div>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default ActionsButtonsBaseModal;
